/**
 * Warns the user before they leave a dashboard with filter or comparison
 * changes they staged but never applied.
 *
 * Staged changes only live for as long as the page does, so leaving silently
 * would throw the work away without the user noticing. Confirming the prompt is
 * how they agree to discard it.
 */
export default (message = 'You have unapplied filter changes. Leave and discard them?') => ({
    guardMessage: message,

    init() {
        this.handleBeforeUnload = (event) => {
            if (!this.hasUnappliedChanges()) {
                return;
            }

            // Browsers show their own wording here; assigning returnValue is
            // what actually triggers the prompt.
            event.preventDefault();
            event.returnValue = '';
        };

        this.handleNavigate = (event) => {
            if (!this.hasUnappliedChanges()) {
                return;
            }

            if (window.confirm(this.guardMessage)) {
                return;
            }

            event.preventDefault();
        };

        window.addEventListener('beforeunload', this.handleBeforeUnload);
        document.addEventListener('livewire:navigate', this.handleNavigate);
    },

    destroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        document.removeEventListener('livewire:navigate', this.handleNavigate);
    },

    hasUnappliedChanges() {
        return this.$wire?.get('hasUnappliedChanges') === true;
    },
});
